import { useTranslation } from "react-i18next";
import { QuotationRequestItemStatus } from "@/types/quotationRequestItem";

const useQuotationStatus = () => {

  const { t } = useTranslation();

  const getQuotationStatus = (status: QuotationRequestItemStatus) => {
    const statusMap = {
      [QuotationRequestItemStatus.UN_READ]: {
        title: t("requirement.nuRead"),
        color: "#ff5500",
      },
      [QuotationRequestItemStatus.READ]: {
        title: t("requirement.read"),
        color: "#2db7f5"
      },
      [QuotationRequestItemStatus.RESOLVE]: {
        title: t("requirement.resolved"),
        color: "#87d068"
      },
      [QuotationRequestItemStatus.REJECT]: {
        title: t("requirement.rejected"),
        color: "#108ee9"
      },
    }

    return statusMap[status]
  }

  return { getQuotationStatus }
}

export default useQuotationStatus;